<div class="card">
  <div class="card-body">
    <app-grid [rowData]="rowData" [columnDefs]="columnDefs" (on_first_data_rendered)="pre_select_nodes($event)"
      (on_row_selected)="change_selection($event)"></app-grid>
  </div>
</div>